{
  "selectAsField": "\"{value}\" ਨੂੰ {fieldName} ਵਜੋਂ ਚੁਣੋ",
  "typeToSearchField": "{fieldName} ਖੋਜਣ ਲਈ ਟਾਈਪ ਕਰੋ",
  "licenseFieldLabel": "ਲਾਇਸੈਂਸ ਪਲੇਟ ਚੁਣੋ (ਜਿਵੇਂ ਕਿ 215BG2)",
  "licenseFieldName": "ਲਾਇਸੈਂਸ ਪਲੇਟ",
  "licensePlaceholder": "ਲਾਇਸੈਂਸ ਪਲੇਟ ਦੁਆਰਾ ਖੋਜੋ",
  "dotFieldLabel": "DOT ਨੰਬਰ ਚੁਣੋ",
  "dotFieldName": "DOT ਨੰਬਰ",
  "dotPlaceholder": "DOT ਨੰਬਰ ਦੁਆਰਾ ਖੋਜੋ",
  "chooseOneOption": "ਹੇਠਾਂ ਦਿੱਤੇ ਵਿਕਲਪਾਂ ਵਿੱਚੋਂ ਇੱਕ ਚੁਣੋ"
}
